import { UPFRONT_PAYMENT_ID } from '../constants/ifp.constants';

export const getValidOfferIds = (
  deviceId: string,
  planId?: string,
  ifpId?: string,
): string[] => {
  return [deviceId, planId, ifpId].filter(
    // Use isNaN here to filter out default IfpId = '36'. This is a Temporary fix
    // Just to unblock E2E testing, will discuss with backend developer to get IFP id pass at gallery or have a proper solution at frontend
    (id) => id && !id.includes(UPFRONT_PAYMENT_ID) && Number.isNaN(Number(id)),
  );
};
